<template>
  <transition enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutUp">
    <div class="alert-notification" v-if="show && showString">
      <div
        class="alert alert-dismissable"
        :class="{
          'alert-danger': alertType === 'danger',
          'alert-success': alertType === 'success',
          'alert-info': alertType === 'info',
          'alert-warning': alertType === 'warning'
        }"
      >
        <button aria-hidden="true" data-dismiss="alert" @click="handleClose" class="close" type="button">×</button>
        {{ alertContent }}
      </div>
    </div>
  </transition>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'AlertNotification',

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      alertType: state => state.common.alertType,
      alertContent: state => state.common.alertContent,
      alertshow: state => state.common.alertshow
    }),
    showString() {
      return typeof this.alertContent === 'string'
    }
  },

  mounted() {},
  methods: {
    ...mapActions(['alertToggle']),
    handleClose() {
      this.alertToggle()
    }
  }
}
</script>
<style>
.alert-notification {
  position: fixed;
  top: 50%;
  left: calc(50% - 180px);
  width: 360px;
  max-width: 360px;
  z-index: 4050;
  padding: 5px;
}
</style>
